import React, { Component, Fragment } from 'react';

class SwitchCheckbox extends Component
{
	state = {
		checked: this.props.checked
	}

	constructor (props) {
		super(props);

		if (this.props.labels) {
			this.uncheckedLabel = this.props.labels[0];
			this.checkedLabel   = this.props.labels[1];
		}

		this.onChange = this.onChange.bind(this);
	}

	onChange (e) {
		this.setState({ checked: e.target.checked });

		if (this.props.onChange) {
			this.props.onChange(e.target.checked);
		}
	}

	render () {
		return (
			<Fragment>
				<div style={{marginRight: '10px'}}>
					{(this.state.checked) ? this.checkedLabel : this.uncheckedLabel}
				</div>
				<label className="active-cues-switch">
					<input type="checkbox" checked={this.state.checked} value={this.state.checked} onChange={this.onChange} />
					<span className="active-cues-switch-slider"></span>
				</label>
			</Fragment>
		);
	}
}

export default SwitchCheckbox;


// WEBPACK FOOTER //
// ./src/Components/SwitchCheckbox.js